import Box from "@mui/joy/Box";
import { AspectRatio, CssBaseline, CssVarsProvider } from "@mui/joy";
import { Link } from "react-router-dom";

export default function PageNotFound() {
  return (
    <CssVarsProvider>
      <CssBaseline />
      <Box
        component="main"
        className="Main"
        sx={[
          {
            p: 0,
            margin: 0,
            maxHeight: "100dvh",
            overflow: "auto",
          },
        ]}
      >
        <Link to="/">
          <Box
            sx={{
              gap: 2,
              p: 2,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <AspectRatio
              variant="plain"
              ratio={1}
              objectFit="contain"
              maxHeight={"80vh"}
              sx={{ bgcolor: "transparent" }}
            >
              <img alt="Page not found" src="/images/page_not_found.png" />
            </AspectRatio>
          </Box>
        </Link>
      </Box>
    </CssVarsProvider>
  );
}
